import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

export default class ReferentialAdminApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public updateReferentialTranslatable(
    referentialId: number,
    translatable: boolean,
  ) {
    const query = `/core/v3/referential/${referentialId}/translatable`;
    return this.post(query, { translatable });
  }

  public deleteReferential(slug: string) {
    return this.delete(`/core/v3/referentials/${slug}`);
  }

  public ReferentialGetList(path: string, queries?: any) {
    const query = `/core/v3/referentials/${path}/admin${qs.stringify(
      queries,
      true,
    )}`;
    return this.get(query);
  }

  public upsertEntities(path: string, payload?: any, queries?: any) {
    const query = `/core/v3/referentials/${path}/admin${qs.stringify(
      queries,
      true,
    )}`;
    return this.post(query, payload);
  }

  public ReferentialGetGroups(referentialName: string) {
    const query = `/core/v3/referentials/${referentialName}/referentialgroups`;
    return this.get(query);
  }

  public ReferentialCreateGroup(referentialName: string, groupName: string) {
    const query = `/core/v3/referentials/${referentialName}/${groupName}`;
    return this.put(query);
  }

  public ReferentialGroupsAddEntities(
    referentialName: string,
    groupName: string,
    entityIds: number[],
  ) {
    const query = `/core/v3/referentials/${referentialName}/${groupName}`;
    const body = {
      data: { entity_ids: entityIds },
    };
    return this.post(query, body);
  }

  public ReferentialGroupsDeleteEntity(
    referentialName: string,
    groupName: string,
    entityId: number,
  ) {
    const query = `/core/v3/referentials/${referentialName}/${groupName}/${entityId}`;
    return this.delete(query);
  }
}
